// src/pages/users/UserList.js
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  Link,
  MenuItem,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  ThemeProvider,
  Typography,
  createTheme,
  useMediaQuery,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import AdminHeader from '../../components/AdminHeader';
import LayoutContainer from '../../components/LayoutContainer';
import userService from '../../services/userService';
import {
  concat,
  filter,
  find,
  has,
  includes,
  isEmpty,
  isEqual,
  isMatch,
  isString,
  join,
  last,
  lastIndexOf,
  map,
  omit,
  reverse,
  sortBy,
} from 'lodash';
import { MdContentCopy } from 'react-icons/md';
import MUIDataTable from 'mui-datatables';
import itemService from '../../services/itemService';
import { toast } from 'react-toastify';
import { createUserOtp, usesFixedOtp } from '../../utils/userOtp';

const formatListValue = (value) => {
  if (value == null || value === '') return '-';
  if (Array.isArray(value)) return value.filter(Boolean).join(', ') || '-';
  if (typeof value !== 'string') return String(value);
  const trimmed = value.trim();
  if (!trimmed) return '-';
  try {
    if (trimmed.startsWith('[') || trimmed.startsWith('{')) {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) return parsed.filter(Boolean).join(', ') || '-';
      if (parsed && typeof parsed === 'object') {
        return Object.values(parsed).filter(Boolean).join(', ') || '-';
      }
    }
  } catch (error) {
    return trimmed.replace(/[[\]"]/g, '').trim() || '-';
  }
  return trimmed;
};

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [filters, setFilters] = useState({});
  const [mobileSearch, setMobileSearch] = useState('');

  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width:799px)', { noSsr: true });
  const roleList = JSON.parse(localStorage?.getItem('roles') || '[]');

  const fetchUsers = async () => {
    const response = await userService.getUsers();
    const rows = await Promise.all(
      (response?.data || []).map(async (data) => {
        console.log(' data?.roles', data);

        const role =
          data?.roles && isString(data?.roles) !== '0'
            ? JSON.parse(data?.roles)[0]
            : false;

            console.log("role",role,roleList,  isEqual(roleList, ['ADMIN', 'SUPER ADMIN']),  (role === 'ADMIN' || role === 'COMMAND CENTER') &&
            isEqual(roleList, ['ADMIN', 'SUPER ADMIN']));
            

        let savedRoles = [];
        try {
          savedRoles = data?.roles ? JSON.parse(data.roles) : [];
        } catch (error) {
          savedRoles = [];
        }
        const usesOtp = usesFixedOtp(savedRoles);
        const phone = String(data?.phone || '');
        let fixedOtp = '';
        if (usesOtp && /^[0-9]{10}$/.test(phone)) {
          const generated = await createUserOtp(phone);
          fixedOtp = generated.otp;
        }

        return {
          ...data,
          otp: fixedOtp,
          isEditable:
            role &&
            (role === 'ADMIN' || role === 'COMMAND CENTER') &&
            isEqual(roleList, ['ADMIN', 'SUPER ADMIN'])
              ? true
              : data?.roles && 
                roleList?.some(
                  (role) =>
                    isString(data?.roles) !== '0' &&
                    JSON.parse(data?.roles)?.includes(role)
                ) || role === 'COMMAND CENTER'
              ? false
              : true,
        };
      }),
    );
    const resData = sortBy(rows, 'username');
    setUsers(resData);
    setTableData(filter(resData, { active: true }));
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleDelete = async (data) => {
    const deleteItemIndex = map(data?.data, (data) => data?.dataIndex);
    const deleteItem = filter(users, (data, index) =>
      includes(deleteItemIndex, index)
    );

    const res = await itemService.deleteProductList({
      table_name: 'users',
      ids: map(deleteItem, 'id'),
    });

    if (res?.status === 204) {
      toast.success('Users deleted successfully');
      setUsers(
        users.filter((item, index) => !includes(deleteItemIndex, index))
      );
    }
  };

  const handleCopy = (link) => {
    const url = link;

    const textarea = document.createElement('textarea');
    textarea.value = url;
    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy'); // Use the execCommand method
      alert('URL copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy: ', err);
    } finally {
      document.body.removeChild(textarea); // Clean up
    }
  };

  const styles = {
    logContainer: {
      borderBottom: '1px solid #ddd', // Light border for separation
      padding: '12px', // Padding inside each log
      margin: '8px 0', // Vertical margin between logs
      borderRadius: '4px', // Rounded corners
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // Subtle shadow
      backgroundColor: '#fafafa', // Light background color
    },
    link: {
      textDecoration: 'none',
      color: '#3f51b5', // Default link color
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
      display: 'inline-block',
      maxWidth: '100%',
      transition: 'color 0.3s ease', // Smooth color transition
    },
    linkHover: {
      color: '#1a73e8', // Color on hover
    },
    noLogsContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      textAlign: 'center',
      margin: '20px 0',
    },
    infoIcon: {
      fontSize: 40,
      marginBottom: 16,
      color: '#a0a0a0',
    },
    noLogsText: {
      color: '#a0a0a0',
    },
  };

  function tryParse(value) {
    try {
      const parsed = JSON.parse(value);
      // Return the parsed data if it is an array or an object
      return Array.isArray(parsed) || typeof parsed === 'object'
        ? !isEmpty(parsed)
          ? join(parsed, ',')
          : '-'
        : value;
    } catch (e) {
      // If parsing fails, return the value as a string
      return value;
    }
  }

  const handleActiveChange = async (val, id) => {
    const obj = find(users, { id: parseInt(id) });
    const data = await userService.updateUser(
      id,
      omit({ ...obj, active: val }, [
        'id',
        'isEditable',
        'password',
        'shift_duration',
      ])
    );
    if (data?.status === 200) {
      fetchUsers();
      toast?.success('User deactivated successfully');
    }
  };

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: false,
        display: false,
      },
    },
    {
      name: 'username',
      label: 'NAME',
      showFilter: true,
      options: {
        filter: false,
        customBodyRender: (value) => value || '-',
      },
    },
    {
      name: 'phone',
      label: 'PHONE',
      showFilter: true,
      options: {
        filter: false,
        customBodyRender: (value) => value || '-',
      },
    },
    ...(includes(roleList, 'ADMIN') ||
    includes(roleList, 'SUPER ADMIN') ||
    includes(roleList, 'SYS ADMIN')
      ? [
          {
            name: 'otp',
            label: 'OTP',
            showFilter: false,
            options: {
              filter: false,
              display: false,
              viewColumns: false,
              download: true,
              customBodyRender: (value) => value || '-',
            },
          },
        ]
      : []),
    {
      name: 'station_type',
      showFilter: true,
      label: 'TYPE',
      options: {
        filter: false,
        display: !isMobile,
        customBodyRender: (value) => value || '-',
      },
    },
    {
      name: 'products',
      label: 'PRODUCTS',
      showFilter: false,
      options: {
        filter: false,
        display: !isMobile,
        customBodyRender: (value) => {
          try {
            if (value && !isEmpty(value)) {
              const parsedValue = JSON.parse(value);

              if (Array.isArray(parsedValue)) {
                return parsedValue
                  .join(',') // Join array items into a single string
                  .split(',') // Split the string back into array-like items
                  .map((item, index) => <div key={index}>{item}</div>);
              } else {
                return '-'; // Return '-' if the parsed value is not an array
              }
            }
          } catch (error) {
            console.error('Invalid JSON:', error, value);
            return '-';
          }
          return '-';
        },
      },
      //   customBodyRender: (value) =>
      //     value
      //       ? isEmpty(JSON.parse(value))
      //         ? '-'
      //         : JSON.parse(value)
      //             .join(',')
      //             .split(',')
      //             .map((item, index) => <div key={index}>{item}</div>)
      //       : '-',
      // },
    },
    {
      name: 'stations',
      label: 'STATIONS',
      showFilter: false,
      options: {
        filter: false,
        display: !isMobile,
        customBodyRender: (value) => {
          if (value && !isEmpty(value)) {
            try {
              if (value && !isEmpty(value)) {
                let data;
                try {
                  // Check if the value is a string and looks like valid JSON (object or array)
                  if (typeof value === 'string' && value.trim()) {
                    const trimmedValue = value.trim();
                    if (
                      (trimmedValue.startsWith('{') &&
                        trimmedValue.endsWith('}')) ||
                      (trimmedValue.startsWith('[') &&
                        trimmedValue.endsWith(']'))
                    ) {
                      data = JSON.parse(value);
                    } else {
                      data = value;
                    }
                  } else {
                    data = value; // If it's not a string, return it as is
                  }
                } catch (e) {
                  // If JSON.parse fails, return the value as is
                  data = value;
                }
                const parsedValue = Array.isArray(data) ? data : [data];

                if (Array.isArray(parsedValue)) {
                  return parsedValue
                    .join(',') // Join array items into a single string
                    .split(',') // Split the string back into array-like items
                    .map((item, index) => <div key={index}>{item}</div>);
                } else {
                  return '-'; // Return '-' if the parsed value is not an array
                }
              }
            } catch (error) {
              console.error('Invalid JSON:', error, value);
              return '-';
            }
          } else {
            return '-';
          }
        },
      },
    },
    {
      name: 'roles',
      label: 'ROLES',
      showFilter: true,
      options: {
        filter: false,
        customBodyRender: (value) =>
          value
            ? JSON.parse(value)
                .join(',')
                .split(',')
                .map((item, index) => <div key={index}>{item}</div>)
            : '-',
      },
    },
    {
      name: 'permissions',
      label: 'PERMISSIONS',
      showFilter: false,
      options: {
        filter: false,
        display: !isMobile,
        customBodyRender: (value) =>
          value && !isEmpty(JSON.parse(value))
            ? JSON.parse(value)
                .join(',')
                .split(',')
                .map((item, index) => <div key={index}>{item}</div>)
            : '-',
      },
    },
    // {
    //   name: 'location',
    //   label: 'LOCATION',
    //   showFilter: false,
    //   options: {
    //     filter: false,
    //     customBodyRender: (value) => value || '-',
    //   },
    // },
     {
      name: 'zones',
      label: 'ZONE',
      showFilter: false,
      options: {
        filter: false,
        customBodyRender: (value) => value || '-',
      },
    },
    {
      name: 'action',
      label: 'ACTION',
      showFilter: false,
      options: {
        sort: false,
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          const user = tableData[dataIndex];
          return (
            <div>
              <IconButton
                onClick={() => navigate(`/users/edit/${user.id}`)}
                disabled={user?.id && !user?.isEditable}
                sx={{
                  cursor: user?.isEditable
                    ? 'pointer !important'
                    : 'not-allowed !important',
                  pointerEvents: 'auto !important',
                }}
              >
                <EditIcon sx={{ color: '#be210b' }} />
              </IconButton>
              {/* {user?.isEditable && isEqual(roleList, ['SUPER ADMIN']) && (
                <IconButton onClick={() => handleDelete(user.id)}>
                  <DeleteIcon sx={{ color: '#be210b' }} />
                </IconButton>
              )} */}
            </div>
          );
        },
      },
    },
  ];

  const formatFilterLabel = (value) => {
  if (value == null || value === '') return '-';
  if (typeof value !== 'string') return String(value);
  const trimmed = value.trim();
  if (!trimmed.startsWith('[') && !trimmed.startsWith('{')) return value;
  try {
    const parsed = JSON.parse(trimmed);
    if (Array.isArray(parsed)) {
      return parsed.filter(Boolean).join(', ') || '-';
    }
  } catch (error) {
    return trimmed.replace(/[[\]"]/g, '').trim() || '-';
  }
  return value;
};

const uniqueValues = useMemo(() => {
    const values = {};
    columns?.forEach((column) => {
      const columnData = users?.map((row) => row[column.name]);
      values[column.name] = [...new Set(columnData)];
    });
    return values;
  }, [columns]);

  const handleApply = () => {
    const filteredValues = filter(users, (item) => isMatch(item, filters));
    setTableData(filteredValues);
  };

  const handleDropdownChange = (columnName, value) => {
    if (value !== 'all') {
      setFilters((prevFilters) => ({
        ...prevFilters,
        [columnName]: value,
      }));
    }
    if (value === 'all' && has(filters, columnName)) {
      setFilters(omit(filters, [columnName]));
    }
  };

  const handleResetFilter = () => {
    setFilters({});
    fetchUsers();
  };

  const CustomFilterDialogFooter = () => {
    return (
      <div
        style={{
          marginTop: '3rem',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '1rem',
          }}
        >
          {filter(columns, 'showFilter').map((column) => (
            <div
              key={column.name}
              style={{
                flexBasis: 'calc(50% - 0.5rem)',
                boxSizing: 'border-box',
                marginTop: '0.7rem',
              }}
            >
              <FormControl
                variant='standard'
                sx={{ m: 1, minWidth: 120 }}
                fullWidth
              >
                <InputLabel
                  id={`filter-${column.name}-label`}
                  style={{ fontSize: '1rem', fontWeight: 400 }}
                >
                  {column.label}
                </InputLabel>
                <Select
                  labelId={`filter-${column.name}-label`}
                  id={`filter-${column.name}`}
                  value={
                    filters[column.name] === true
                      ? 'TRUE'
                      : filters[column.name] === false
                      ? 'FALSE'
                      : filters[column.name] || 'all' || ''
                  }
                  onChange={(e) =>
                    handleDropdownChange(
                      column.name,
                      e.target.value === 'TRUE'
                        ? true
                        : e.target.value === 'FALSE'
                        ? false
                        : e.target.value
                    )
                  }
                  label={column.label}
                >
                  <MenuItem value='all'>All</MenuItem>
                  {column?.name === 'active'
                    ? ['TRUE', 'FALSE'].map((value, idx) => (
                        <MenuItem key={idx} value={value}>
                          {value === 'TRUE'
                            ? 'True'?.toUpperCase()
                            : 'False'?.toUpperCase()}
                        </MenuItem>
                      ))
                    : uniqueValues[column.name]?.map((value, idx) => (
                        <MenuItem key={idx} value={value}>
                          {formatFilterLabel(value)}
                        </MenuItem>
                      ))}
                </Select>
              </FormControl>
            </div>
          ))}
        </div>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            sx={{
              mt: 2,
              background: '#2152a1',
              display: 'block',
            }}
            onClick={handleApply}
            variant='contained'
          >
            Apply
          </Button>
          <Button
            sx={{
              mt: 1,
              pr: 4,
              pl: 4,
              background: '#2152a1',
              display: 'block',
            }}
            onClick={handleResetFilter}
            variant='contained'
          >
            Reset
          </Button>
        </Box>
      </div>
    );
  };

  const mobileUsers = useMemo(() => {
    const query = mobileSearch.trim().toLowerCase();
    if (!query) return tableData;
    return tableData.filter((user) => {
      const haystack = [
        user?.username,
        user?.phone,
        formatListValue(user?.roles),
        user?.zones,
        user?.station_type,
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      return haystack.includes(query);
    });
  }, [tableData, mobileSearch]);

  const options = {
    expandableRows: false,
    filterOptions: 'fullWidth',
    // download: false,
    responsive: 'standard',
    selectableRows: isEqual(roleList, ['SUPER ADMIN']) ? 'multiple' : 'none',
    selectableRowsOnClick: true,
    customFilterDialogFooter: CustomFilterDialogFooter,
    isRowSelectable: (dataIndex) => {
      const user = users[dataIndex];
      const roles = user?.roles ? JSON.parse(user.roles) : [];
      return roles.includes('USER');
    },
    print: false,
    search: true,
    filter: true,
    viewColumns: true,
    onRowsDelete: (rowsDeleted) => {
      const confirmDelete = window.confirm(
        `Are you sure you want to delete ${rowsDeleted.data.length} row(s)?`
      );
      if (confirmDelete) {
        handleDelete(rowsDeleted);
      } else {
        return false;
      }
    },
    rowsPerPageOptions: [30, 50, 100],
    rowsPerPage: 30,
    // viewColumns: false,
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      const escapeCell = (value) => {
        const text =
          value === undefined || value === null
            ? ''
            : typeof value === 'string' || typeof value === 'number'
              ? String(value)
              : '';
        return `"${text.replace(/"/g, '""')}"`;
      };
      const phoneIndex = columns.findIndex((column) => column.name === 'phone');
      const otpByPhone = {};
      tableData.forEach((user) => {
        if (user?.phone) otpByPhone[String(user.phone)] = user.otp || '-';
      });
      const labels = columns.map((column) => column.label || column.name);
      const headerCells =
        phoneIndex >= 0
          ? [
              ...labels.slice(0, phoneIndex + 1),
              'OTP',
              ...labels.slice(phoneIndex + 1),
            ]
          : [...labels, 'OTP'];
      const header = headerCells.map(escapeCell).join(',');
      const body = data
        .map((row) => {
          const cells = (row.data || []).map(escapeCell);
          const phone = phoneIndex >= 0 ? row.data?.[phoneIndex] : '';
          const otpCell = escapeCell(otpByPhone[String(phone || '')] || '-');
          if (phoneIndex >= 0) {
            cells.splice(phoneIndex + 1, 0, otpCell);
          } else {
            cells.push(otpCell);
          }
          return cells.join(',');
        })
        .join('\r\n');
      return `${header}\r\n${body}`;
    },
  };

  const getMuiTheme = () =>
    createTheme({
      components: {
        MUIDataTable: {
          styleOverrides: {
            root: {
              boxShadow: 'none',
              backgroundColor: '#FFF',
            },
          },
        },
        MUIDataTableHeadCell: {
          styleOverrides: {
            root: {
              backgroundColor: '#2F3542', // Keep background as you have it
              color: '#fff !important', // Ensure heading text is white
              border: 'none',
              fontWeight: '550 !important',
              '&:nth-last-of-type(1)': {
                borderTopRightRadius: '1rem',
                // borderBottomRightRadius: '0.2rem',
              },
            },
            sortActive: {
              color: '#fff !important', // Active sort icon color should also be white
            },
            sortAction: {
              '& .MuiTableSortLabel-icon': {
                color: '#fff !important', // Ensure sort icon stays white when active
              },
            },
            toolButton: {
              fontWeight: 'bold',
              fontSize: '0.675rem !important',
              paddingTop: '3px',
              paddingBottom: '3px',
            },
          },
        },
        MuiIconButton: {
          styleOverrides: {
            root: {
              padding: '2px 8px 2px 8px',
            },
          },
        },
        MuiTablePagination: {
          styleOverrides: {
            root: {
              backgroundColor: '#FFFFFF',
              height: '40px',
            },
            select: {
              backgroundColor: '#FFFFFF',
            },
            actions: {
              backgroundColor: '#FFFFFF',
            },
          },
        },
        MUIDataTableSelectCell: {
          styleOverrides: {
            headerCell: {
              border: 'none',
              borderTopLeftRadius: '0.2rem',
              borderBottomLeftRadius: '0.2rem',
              backgroundColor: '#2F3542',
              '& .MuiCheckbox-root': {
                color: '#fff',
                padding: '4px',
              },
            },
          },
        },
        MuiToolbar: {
          styleOverrides: {
            root: {
              minHeight: '30px!important',
              padding: '0px!important',
            },
          },
        },
        MuiCheckbox: {
          styleOverrides: {
            root: {
              padding: '4px',
            },
          },
        },
        MUIDataTableBodyRow: {
          styleOverrides: {
            root: {
              '&:nth-of-type(even)': {
                backgroundColor: '#EAF3FF',
              },
              '&:nth-of-type(odd)': {
                backgroundColor: '#FFF',
              },
              '& td': {
                textAlign: 'left', // Center align body text data
                border: 'none',
              },
              marginBottom: '10px',
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            root: {
              color: '#fff',
              padding: '6px 4px !important',
              fontWeight: '550 !important',
              fontSize: '0.675rem !important',
              justifyContent: 'start !important',
            },
          },
        },
        MuiTableCell: {
          styleOverrides: {
            root: {
              padding: '6px 12px !important',
              fontSize: '0.675rem',
            },
          },
        },
        MUIDataTableBodyCell: {
          styleOverrides: {
            root: {
              fontSize: '0.675rem !important',
            },
          },
        },
        MuiPopover: {
          styleOverrides: {
            paper: {
              minWidth: '500px !important', // Increase the width of filter dropdown
              padding: '10px', // Add padding inside the dropdown
              borderRadius: '8px', // Optionally, round the corners
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)', // Add a subtle shadow for better visibility
              backgroundColor: '#fff', // Background color (you can change it)
            },
          },
        },
        MuiMenu: {
          styleOverrides: {
            paper: {
              minWidth: '200px  !important',
              maxHeight: '200px',
              overflowY: 'auto',
            },
          },
        },
        MuiMenuItem: {
          styleOverrides: {
            root: {
              fontSize: '0.675rem !important',
              fontWeight: 500,
              color: '#333',
              padding: '8px 16px',
              '&:hover': {
                backgroundColor: '#F5F5F5',
              },
            },
          },
        },
        MuiSelect: {
          styleOverrides: {
            select: {
              fontSize: '0.675rem !important',
              padding: '6px 10px',
            },
          },
        },
      },
    });

  return (
    <LayoutContainer>
      <AdminHeader title='USERS' />
      <div
        className='page-content-wrapper scrollable'
        style={{
          padding: isMobile ? '0.75rem' : undefined,
          boxSizing: 'border-box',
          width: '100%',
          minWidth: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mb: 2,
          }}
        >
          <Button
            variant='contained'
            sx={{
              backgroundColor: '#be210b',
              textTransform: 'none',
              borderRadius: 2,
              fontWeight: 700,
              '&:hover': { backgroundColor: '#a61c09' },
            }}
            onClick={() => navigate('/users/new')}
          >
            ADD USER
          </Button>
        </Box>
        {isMobile ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
            <TextField
              fullWidth
              size='small'
              placeholder={'Search name, phone, etc...'.toUpperCase()}
              value={mobileSearch}
              onChange={(event) => setMobileSearch(event.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon sx={{ color: '#be210b', fontSize: 20 }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                  backgroundColor: '#fff',
                  '& fieldset': { borderColor: '#efc4bd' },
                  '&:hover fieldset': { borderColor: '#be210b' },
                  '&.Mui-focused fieldset': {
                    borderColor: '#be210b',
                    borderWidth: 1.5,
                  },
                },
              }}
            />

            {mobileUsers.length === 0 ? (
              <Box
                sx={{
                  p: 3,
                  textAlign: 'center',
                  borderRadius: '12px',
                  border: '1px dashed #efc4bd',
                  backgroundColor: '#fffbfa',
                  color: '#667085',
                }}
              >
                No users found
              </Box>
            ) : (
              mobileUsers.map((user) => (
                <Box
                  key={user.id}
                  sx={{
                    p: 1.5,
                    borderRadius: '12px',
                    border: '1px solid #f0d5d1',
                    backgroundColor: '#fff',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      justifyContent: 'space-between',
                      gap: 1,
                      mb: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: '#101828',
                        fontSize: '0.95rem',
                        textTransform: 'none',
                        lineHeight: 1.35,
                        wordBreak: 'break-word',
                      }}
                    >
                      {user.username || '-'}
                    </Typography>
                    <IconButton
                      size='small'
                      onClick={() => navigate(`/users/edit/${user.id}`)}
                      disabled={user?.id && !user?.isEditable}
                      sx={{
                        flexShrink: 0,
                        cursor: user?.isEditable
                          ? 'pointer !important'
                          : 'not-allowed !important',
                        pointerEvents: 'auto !important',
                      }}
                    >
                      <EditIcon sx={{ color: '#be210b', fontSize: 20 }} />
                    </IconButton>
                  </Box>

                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.55 }}>
                    <Typography sx={{ fontSize: '0.8rem', color: '#475467', textTransform: 'none' }}>
                      <Box component='span' sx={{ color: '#667085', fontWeight: 700 }}>
                        Phone:{' '}
                      </Box>
                      {user.phone || '-'}
                    </Typography>
                    <Typography sx={{ fontSize: '0.8rem', color: '#475467', textTransform: 'none' }}>
                      <Box component='span' sx={{ color: '#667085', fontWeight: 700 }}>
                        Roles:{' '}
                      </Box>
                      {formatListValue(user.roles)}
                    </Typography>
                    <Typography sx={{ fontSize: '0.8rem', color: '#475467', textTransform: 'none' }}>
                      <Box component='span' sx={{ color: '#667085', fontWeight: 700 }}>
                        Zone:{' '}
                      </Box>
                      {user.zones || '-'}
                    </Typography>
                  </Box>
                </Box>
              ))
            )}
          </Box>
        ) : (
          <ThemeProvider theme={getMuiTheme()}>
            <Box
              sx={{
                width: '100%',
                minWidth: 0,
                overflowX: 'auto',
                '& .MuiPaper-root': {
                  boxShadow: 'none',
                },
                '& [class*="MUIDataTableBodyCell-root"]': {
                  textTransform: 'none',
                },
              }}
            >
              <MUIDataTable data={tableData} columns={columns} options={options} />
            </Box>
          </ThemeProvider>
        )}

        {/* <Table className='table'>
          <TableHead className='tableHead'>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Products</TableCell>
              <TableCell>Station</TableCell>
              <TableCell>Roles</TableCell>
              <TableCell>Permission</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className='tableBody'>
            {users.map((user, index) => (
              <TableRow
                key={user.id}
                sx={{
                  backgroundColor: index % 2 === 0 ? '#fff' : '#eaf3ff',
                }}
              >
                <TableCell>{user.username || '-'}</TableCell>
                <TableCell>{user.phone || '-'}</TableCell>
                <TableCell>{user.station_type || '-'}</TableCell>
                <TableCell>
                  {user?.products
                    ? isEmpty(JSON.parse(user?.products))
                      ? '-'
                      : join(JSON.parse(user?.products), ',')
                    : '-'}
                </TableCell>
                <TableCell>
                  {user?.stations
                    ? isString(user?.stations)
                      ? tryParse(user?.stations)
                      : join(user?.stations, ',')
                    : '-'}
                </TableCell>
                <TableCell>
                  {user?.roles ? join(JSON.parse(user?.roles), ',') : '-'}
                </TableCell>
                <TableCell>
                  {user?.permissions && !isEmpty(JSON.parse(user?.permissions))
                    ? join(JSON.parse(user?.permissions), ',')
                    : '-'}
                </TableCell>
                <TableCell>
                  <IconButton
                    onClick={() => navigate(`/users/edit/${user.id}`)}
                    disabled={!user?.isEditable}
                    sx={{
                      cursor: user?.isEditable
                        ? 'pointer !important'
                        : 'not-allowed !important',
                      pointerEvents: 'auto !important',
                    }}
                  >
                    <EditIcon sx={{ color: '#be210b' }} />
                  </IconButton>
                  {user?.isEditable && isEqual(roleList, ['SUPER ADMIN']) && (
                    <IconButton onClick={() => handleDelete(user.id)}>
                      <DeleteIcon sx={{ color: '#be210b' }} />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table> */}
      </div>
    </LayoutContainer>
  );
};

export default UserList;
